<app-loading-panel [isLoading]="isLoading" [size]="'small'"></app-loading-panel>

<div *ngIf="markers">

    <div *ngIf="markers.policyCarValue">
        <span class="error-label">
            <kendo-icon name="check" themeColor="success"></kendo-icon>
            <b>{{markers.policyCarValue}}</b>
        </span>
    </div>

    <div *ngIf="!markers.policyCarValue">
        <span class="error-label">
            <b> <kendo-icon name="warning" themeColor="error"></kendo-icon>
                {{'claims-center.claimDetailsForm.policyCarValueIsNotDefined' | translate}}</b>
        </span>
    </div>

    <div *ngIf="!markers.partsDeprecationStateId">
        <span class="error-label">
            <b> <kendo-icon name="warning" themeColor="error"></kendo-icon>
                {{'claims-center.claimDetailsForm.partsDeprecationStateIdIsNotDefined' | translate}}</b>
        </span>
    </div>

    <div *ngIf="markers.partsDeprecationStateId > 0">
        <span class="error-label">
            <b> <kendo-icon name="warning" themeColor="error"></kendo-icon>
                {{'claims-center.claimDetailsForm.partsDepreciationState' | translate}} :
                {{markers.partsDeprecationStateId | staticDictionaryCaption:'partsDepreciationState' | async}}</b>
        </span>
    </div>


    <div class="summary-grid">
        <div class="summary-cell summary-header">{{'claims-center.claimDetailsForm.kupValue' | translate}}</div>
        <div class="summary-cell summary-header">{{'claims-center.claimDetailsForm.pdrLaborInvoicedPartially' |
            translate}}</div>
        <div class="summary-cell summary-header">{{'claims-center.claimDetailsForm.pdrLaborInvoicedFinally' |
            translate}}</div>
        <div class="summary-cell summary-header"></div>

        <div class="summary-cell summary-value">{{(markers?.inspectionCardTotalAmount || 0) | number:'1.2-2'}}</div>
        <div class="summary-cell summary-value">{{(pdrLabourInvoicedPartially || 0) | number:'1.2-2'}}</div>
        <div class="summary-cell summary-value">{{(pdrLabourInvoicedFinally || 0) | number:'1.2-2'}}</div>
        <div class="summary-cell summary-result">
            <kendo-icon *ngIf="calculatePdrLabourResult()" name="check-circle" themeColor="success"></kendo-icon>
            <kendo-icon *ngIf="!calculatePdrLabourResult()" name="error" themeColor="error"></kendo-icon>
        </div>
    </div>

    <div class="summary-grid summary-grid-5">
        <div class="summary-cell summary-header">{{'claims-center.claimDetailsForm.partsFromOrders' | translate}}</div>
        <div class="summary-cell summary-header">{{'claims-center.claimDetailsForm.partsInvoicedPartially' | translate}}
        </div>
        <div class="summary-cell summary-header">{{'claims-center.claimDetailsForm.partsInvoicedFinally' | translate}}
        </div>
        <div class="summary-cell summary-header">{{'claims-center.claimDetailsForm.partsDiscountPartially' | translate}}
        </div>
        <div class="summary-cell summary-header">{{'claims-center.claimDetailsForm.partsDiscountFinally' | translate}}
        </div>
        <div class="summary-cell summary-header"></div>

        <div class="summary-cell summary-value">{{(markers?.partsTotalValue || 0) | number:'1.2-2'}}</div>
        <div class="summary-cell summary-value clickable" [title]="partsInvoicedPartiallyTooltip()">
            {{(partsOriginalInvoicedPartially || 0) + (partsAlternativeInvoicedPartially || 0) | number:'1.2-2' }}</div>
        <div class="summary-cell summary-value clickable" [title]="partsInvoicedFinallyTooltip()">
            {{(partsOriginalInvoicedFinally || 0) + (partsAlternativeInvoicedFinally || 0) | number:'1.2-2' }}</div>
        <div class="summary-cell summary-value">{{partsDiscountPartially || 0 | number:'1.2-2' }}</div>
        <div class="summary-cell summary-value">{{partsDiscountFinally || 0 | number:'1.2-2' }}</div>
        <div class="summary-cell summary-result">
            <kendo-icon *ngIf="calculatePartsResult()" name="check-circle" themeColor="success"></kendo-icon>
            <kendo-icon *ngIf="!calculatePartsResult()" name="error" themeColor="error"></kendo-icon>
        </div>
    </div>

    <div class="summary-grid">
        <div class="summary-cell summary-header">{{'claims-center.claimDetailsForm.normaliesFromOrders' | translate}}
        </div>
        <div class="summary-cell summary-header">{{'claims-center.claimDetailsForm.normaliesInvoicedPartially' |
            translate}}</div>
        <div class="summary-cell summary-header">{{'claims-center.claimDetailsForm.normaliesInvoicedFinally' |
            translate}}</div>
        <div class="summary-cell summary-header"></div>

        <div class="summary-cell summary-value">{{(markers?.normaliesValue || 0) | number:'1.2-2'}}</div>
        <div class="summary-cell summary-value">{{normaliesInvoicedPartially || 0 | number:'1.2-2' }}</div>
        <div class="summary-cell summary-value">{{normaliesInvoicedFinally || 0 | number:'1.2-2' }}</div>
        <div class="summary-cell summary-result">
            <kendo-icon *ngIf="calculateNormaliesResult()" name="check-circle" themeColor="success"></kendo-icon>
            <kendo-icon *ngIf="!calculateNormaliesResult()" name="error" themeColor="error"></kendo-icon>
        </div>
    </div>
</div>